import { apiClient } from './client'

export interface Holiday {
  id: string
  org_id: string
  date: string
  name: string
  is_recurring: boolean
  country: string
  created_at: string
  updated_at: string
}

export interface HolidayInput {
  date: string
  name: string
  is_recurring?: boolean
  country?: string
}

export async function listHolidays(year?: number): Promise<Holiday[]> {
  const response = await apiClient.get<Holiday[]>('/holidays', { params: year ? { year } : {} })
  return response.data
}
export async function createHoliday(data: HolidayInput): Promise<Holiday> {
  const response = await apiClient.post<Holiday>('/holidays', data)
  return response.data
}
export async function updateHoliday(id: string, data: Partial<HolidayInput>): Promise<Holiday> {
  const response = await apiClient.put<Holiday>(`/holidays/${id}`, data)
  return response.data
}
export async function deleteHoliday(id: string): Promise<void> {
  await apiClient.delete(`/holidays/${id}`)
}
export async function seedPakistanHolidays(year: number): Promise<Holiday[]> {
  const response = await apiClient.post<Holiday[]>(`/holidays/seed-pakistan?year=${year}`)
  return response.data
}
